'use client';
import { Button } from '@/components/ui/button';

import React from 'react';

import { Input } from '@chakra-ui/react';
import { IPropsComment } from './_types';
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from '@/components/ui/dialog';
import { useTranslations } from 'next-intl';

const CommentDesktop = ({
  onOpenChange,
  handleSaveComment,
  setComment,
  comment,
}: IPropsComment) => {
  const t = useTranslations();
  return (
    <>
      <DialogRoot
        placement='center'
        lazyMount
        open={comment.isOpen}
        onOpenChange={onOpenChange}
      >
        <DialogContent rounded={12}>
          <DialogHeader px={6}>
            <DialogTitle color={'text'} textAlign={'center'}>
              {t('comment_to_product')}
            </DialogTitle>
          </DialogHeader>
          <DialogBody px={6}>
            <Input
              onChange={(e) =>
                setComment((prevState) => ({
                  ...prevState,
                  comment: e.target.value,
                }))
              }
              value={comment.comment}
              size='xl'
              h={'56px'}
              name='comment'
              border={'none'}
              outline={'none'}
              rounded={16}
              placeholder={t('comment')}
              color={'text'}
              variant={'subtle'}
              bg={'background'}
            />
          </DialogBody>
          <DialogFooter p={6}>
            <Button
              bg='primary'
              color='primary.text'
              _hover={{ bg: 'primary.hover' }}
              w={'full'}
              size={'xl'}
              h={'48px'}
              rounded={8}
              onClick={handleSaveComment}
              disabled={!Boolean(comment?.comment)}
            >
              {t('ready')}
            </Button>
          </DialogFooter>
          <DialogCloseTrigger color='text' _hover={{ bg: 'background' }} />
        </DialogContent>
      </DialogRoot>
      {/* <DrawerRoot
        placement={'bottom'}
        open={comment.isOpen}
        onOpenChange={onOpenChange}
      >
        <DrawerBackdrop />
        <DrawerContent roundedTopRight={24} roundedTopLeft={24}>
          <DrawerHeader>
            <DrawerTitle>Комментарий к блюду</DrawerTitle>
          </DrawerHeader>
          <DrawerBody pb={4}>
            <Input
              onChange={(e) =>
                setComment((prevState) => ({
                  ...prevState,
                  comment: e.target.value,
                }))
              }
              value={comment.comment}
              size='xl'
              h={'56px'}
              name='comment'
              border={'none'}
              outline={'none'}
              rounded={16}
              placeholder='Комментарий'
              variant={'subtle'}
            />
          </DrawerBody>
          <DrawerFooter pt={4}>
            <Button
              bg={'primary'}
              w={'full'}
              size={'xl'}
              h={'56px'}
              rounded={16}
              onClick={handleSaveComment}
              disabled={!Boolean(comment?.comment)}
            >
              Готово
            </Button>
          </DrawerFooter>
          <DrawerCloseTrigger />
        </DrawerContent>
      </DrawerRoot> */}
    </>
  );
};

export default CommentDesktop;
